<template>
  <div
    class="swiper-container pro-latest-product"
    id="latest-box"
    v-swiper:mySwiper="swiperOption"
  >
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(item, index) in latestProductList"
        :key="index"
      >
        <router-link
          :to="{
            name: item.type === 1 ? 'MajorDetail' : 'CourseDetail',
            params: { id: item.productId },
          }"
          class="latest-product-item"
        >
          <div class="hot-product-img">
            <div class="can-integral" v-if="item.isIntegral"></div>
            <div class="can-live" v-if="item.hasLive"></div>
            <img :src="concatImageUrl(item.image, 260, 130)" />
          </div>
          <h3 class="hot-product-title">{{ item.name }}</h3>
          <span class="hot-product-type">【{{ item.specialName }}】</span>
          <span class="hot-product-price">
            <span
              v-show="formatPrice(item.discountPrice, item.price)[0] !== '-1'"
              >￥{{ formatPrice(item.discountPrice, item.price)[0] }}</span
            >
            <s
              v-show="formatPrice(item.discountPrice, item.price)[1] !== '-1'"
              style="
                margin-left: 8px;
                color: #808080;
                font-weight: normal;
                font-size: 12px;
              "
              >￥{{ formatPrice(item.discountPrice, item.price)[1] }}</s
            ></span
          >
        </router-link>
      </div>
    </div>
    <div class="swiper-pagination latest-pagination"></div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
export default {
  name: "carrousel-theme",
  mixins: [siteMixin],
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      latestProductList: [],
      swiperOption: {
        slidesPerView: 4,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
        pagination: {
          el: ".latest-pagination",
          clickable: true,
        },
      },
    };
  },
  watch: {
    data() {
      this.latestProductList = this.data;
    },
  },
  mounted() {},
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "~swiper/css/swiper.css";
.pro-latest-product {
  padding-bottom: 35px !important;
  .can-integral {
    .can-integral();
    left: 0;
    top: 0;
  }
  .can-live {
    .can-live();
    left: -1px;
    bottom: 0;
  }
  .latest-product-item {
    display: block;
    width: 260px;
    height: 200px;
    margin: 30px 20px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 1px 1px 5px #ccc;
    background-color: #fff;
    position: relative;

    &:hover {
      background-color: #ccc;

      img {
        opacity: 0.8;
      }
    }

    .hot-product-img {
      position: relative;
      width: 100%;
      height: 130px;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    .hot-product-title {
      padding: 0 5px;
      height: 40px;
      line-height: 40px;
      color: #333;
      .ellipsis();
    }

    .hot-product-type {
      color: #999;
    }

    .hot-product-price {
      float: right;
      color: #ff6600;
      margin-right: 10px;
      margin-top: 2px;
      font-weight: bold;
    }
  }

  /deep/ .latest-pagination {
    bottom: 20px !important;

    .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      border-radius: 20px;
      transition: width 0.2s ease-in-out;
    }

    .swiper-pagination-bullet-active {
      background: #41a5fd;
      width: 45px !important;
    }
  }
}
</style>
